import { PlanNames } from '../../planNames';
export const stripePriceToPlanMap = {
    'price_1NOiWNBps2CRxBX09ApA4A4u': PlanNames.Mini,
    'price_1NOiVbBps2CRxBX0l2kW6VFG': PlanNames.Starter,
    'price_1NOdFkBps2CRxBX06D9pWeMj': PlanNames.Professional,
    'price_1NOiYpBps2CRxBX0TCwIBtC4': PlanNames.Multi,
    // Legacy Test
    'price_1OATG1Bps2CRxBX0uDwGHqpk': PlanNames.LegacyStarter,
};
//# sourceMappingURL=jackTesting.js.map